import Component from '../component';

// The extra padding to leave so we don’t scroll to the very pixel of the target
const EXTRA_PADDING = 30;

export default class OffsetAnchor extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$targetElement = $(this.$element.attr('href'))[0];
    this.$bodyElement = $('.wrapper, html');
    this.$navBarElement = $('.navbar');

    if (this.$targetElement) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.handleClick = this.handleClick.bind(this);

    this.$element.on('click.OffsetAnchor', this.handleClick);
  }

  unbindEvents() {
    this.$element.off('click.OffsetAnchor', this.handleClick);
  }

  handleClick(event) {
    const animationData = {scrollTop: `${this.calculatedScrollOffset()}px`};
    const animationConfiguration = {duration: 500};
    this.$bodyElement.stop().animate(animationData, animationConfiguration);

    event.preventDefault();
  }

  calculatedScrollOffset() {
    return (
      this.$targetElement.offsetTop +
      (this.$navBarElement.outerHeight() || 0) -
      EXTRA_PADDING
    );
  }
}
